import { render, staticRenderFns } from "./SvgRender.vue?vue&type=template&id=8d010556"
import script from "./SvgRender.vue?vue&type=script&lang=js"
export * from "./SvgRender.vue?vue&type=script&lang=js"
import style0 from "./SvgRender.vue?vue&type=style&index=0&id=8d010556&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports